/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-07-03T09:53:25.232
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';

import {
	saveRentRepairWorkOrderDetails,
	getRentRepairWorkOrderDetailsCreateInit,
	getRentRepairWorkOrderDetailsEditInit,
	getRentRepairWorkOrderDetailsView,
	deleteRentRepairWorkOrderDetails
} from '@api/rentmanage/RentRepairWorkOrderDetails';

import {
	cloneObj
} from '@/plugins/utils';

import RespCommonDef from '@/plugins/utils/RespCommonDef';

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary),
		CompoundEntityDictionaryAdd: cloneObj(RespCommonDef.CompoundEntityDictionary),
	},

	actions: {
		getRentRepairWorkOrderDetailsCreateInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				getRentRepairWorkOrderDetailsCreateInit({})
					.then(async res => {
						state.CompoundEntityDictionaryAdd = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getRentRepairWorkOrderDetailsEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentRepairWorkOrderDetailsEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},


		saveRentRepairWorkOrderDetails({}, RentRepairWorkOrderDetails) {
			return new Promise((resolve, reject) => {
				saveRentRepairWorkOrderDetails(RentRepairWorkOrderDetails)
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getRentRepairWorkOrderDetailsView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentRepairWorkOrderDetailsView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteRentRepairWorkOrderDetails({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteRentRepairWorkOrderDetails({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		}
	}
};
